<script setup>
   import { onMounted, ref, watchEffect, inject, computed } from 'vue'
   import { useRoute, useRouter, RouterView } from 'vue-router'
   import LoadingScreen from '@/components/Loading/LoadingScreen.vue'
   import MainLayout from '@/layouts/MainLayout.vue'
   import PageLayout from '@/layouts/PageLayout.vue'
   import PublicLayout from '@/layouts/PublicLayout.vue'
   import Toasts from '@/components/Notifications/Toasts.vue'
   import MaintenanceMode from '@/components/Development/MaintenanceMode.vue'
   import { useEnvironment } from '@/config'

   const route = useRoute()
   const router = useRouter()

   const $storeAuth = inject('$storeAuth')
   const $storeApp = inject('$storeApp')

   onMounted(() => {
      // document.body.setAttribute('data-theme', 'dark')

      const handleModalEvent = event => $storeApp.setModalEvent(event, route.name)
      document.addEventListener('show.bs.modal', handleModalEvent)
      document.addEventListener('hide.bs.modal', handleModalEvent)
   })

   const environment = ref(false)
   watchEffect(() => {
      environment.value = useEnvironment().value
      if(environment.value == 'development') document.body.classList.add('is-development')
   })

   const isAuthenticated = ref(false)
   watchEffect(() => isAuthenticated.value = $storeAuth.isAuthenticated)

   watchEffect(() => {
      if(isAuthenticated.value && route.meta?.layout == 'PublicLayout')
         router.push({ name: 'home' })
   })
</script>

<template>
   <MainLayout v-if="$route.meta.layout == 'MainLayout'" />
   <PublicLayout v-else-if="$route.meta.layout == 'PublicLayout'" />
   <PageLayout v-if="$route.meta.layout == 'PageLayout'" />
   <LoadingScreen />
   <Toasts />
   <MaintenanceMode />
</template>